// src/services/documentService.ts
import { AxiosResponse } from 'axios';
import apiClient from './apiClient';

/**
 * ドキュメントアップロード API
 * POST: /document/upload/
 * ※ ファイルアップロードのため FormData を利用
 * @param file アップロードするファイル
 */
export const uploadDocument = async (file: File): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post('/chat/document/upload/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getDocumentStatus = async (
  documentId: number
): Promise<AxiosResponse<{ status: string }>> => {
  return apiClient.get(`/chat/document/status/${documentId}/`);
};

export interface DocumentSummary {
  id: number;
  document_name: string;
  page_count: number;
  status: string;
  created_at: string;
}

export interface DocumentDetail {
  id: number;
  document_name: string;
  document_text: string;
  original_file: string;
  page_count: number;
  status: string;
  weaviate_uuids: string[];
  created_at: string;
}

/**
 * ドキュメント一覧取得 API
 * GET: /document/list/
 */
export const getDocumentList = async (): Promise<
  AxiosResponse<DocumentSummary[]>
> => {
  return apiClient.get('/chat/document/list/');
};

/**
 * ドキュメント詳細取得 API
 * GET: /document/list/
 */

export const getDocumentDetail = async (
  documentId: number
): Promise<AxiosResponse<DocumentDetail>> => {
  return apiClient.get(`/chat/document/detail/${documentId}/`);
};

/**
 * ドキュメント削除 API
 * DELETE: /document/delete/<document_id>/
 * @param documentId 削除するドキュメントのID
 */
export const deleteDocument = async (
  documentId: number
): Promise<AxiosResponse> => {
  return apiClient.delete(`/chat/document/delete/${documentId}/`);
};

/**
 * ドキュメント検索クエリ API
 * GET: /chat/document/query/
 * @param question 質問文字列
 */
export const queryDocument = async (
  question: string
): Promise<AxiosResponse<any>> => {
  return apiClient.get('/chat/document/query/', {
    params: { query: question },
  });
};
